module.exports = __webpack_public_path__ + "media/bootstrap-icons/pause-2107665c.svg";